module.exports = __webpack_public_path__ + "static/quini-a6bebdfbfffda50600815a9c1c959228.svg";